import { AddressSearchResponse } from '@application/components/address-search/AddressSearch';
import { useCallback } from 'react';
import { useLocalStorage } from 'usehooks-ts';

const STORAGE_KEY = 'siteLookup.recentSearches';
const MAX_RECENT_SEARCHES = 10;

const useRecentSearches = () => {
  const [recentSearches, setRecentSearches] = useLocalStorage<AddressSearchResponse[]>(STORAGE_KEY, []);

  const addRecentSearch = useCallback(
    (address: AddressSearchResponse) => {
      if (!address.fullAddress) {
        return;
      }

      setRecentSearches((previous) => {
        // De-dupe by fullAddress (best-effort), keep newest first, cap the list.
        const withoutDuplicate = previous.filter((search) => search.fullAddress !== address.fullAddress);
        return [address, ...withoutDuplicate].slice(0, MAX_RECENT_SEARCHES);
      });
    },
    [setRecentSearches],
  );

  const clearRecentSearches = useCallback(() => {
    setRecentSearches([]);
  }, [setRecentSearches]);

  return { recentSearches, addRecentSearch, clearRecentSearches };
};

export default useRecentSearches;
